import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "config-page" }
const _hoisted_2 = { class: "config-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "config-content-wrapper" }
const _hoisted_5 = { class: "config-form-left" }
const _hoisted_6 = { class: "config-form-right" }

import { ref, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import SystemSideMenu from '@/components/SystemSideMenu.vue'
import { PlusOutlined } from '@ant-design/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigManager',
  setup(__props) {

const route = useRoute()
const activeTab = ref('system')

// 表单数据模型
const formState = reactive({
  assignedRole: 'user', // 注册分配的角色
  weatherApiKey: '', // 和风天气秘钥
  feedbackNotifyUser: '', // 问题反馈通知用户
  checkUserLogout: 'allow', // 是否检查用户注销
  enableSSO: 'disable', // 启用单点会话登录
  opLogRetention: 'permanent', // 操作日志保留时间
  loginLogRetention: 'permanent', // 登陆日志保留时间
  autoCreateProject: '', // 注册自动创建项目和区域
})

const saveConfig = () => {
  console.log('Saving config:', formState)
  // 在这里添加保存配置的逻辑
}

// 监听路由确保侧边栏高亮
const selectedKeys = ref(['config'])
const openKeys = ref(['system'])
watch(
  () => route.path,
  (path) => {
    if (path.startsWith('/system/config')) {
      selectedKeys.value = ['config']
      openKeys.value = ['system']
    } else {
      // 根据实际路由结构调整
      selectedKeys.value = [] 
      openKeys.value = []
    }
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_tabs, {
              activeKey: activeTab.value,
              "onUpdate:activeKey": _cache[8] || (_cache[8] = ($event: any) => ((activeTab).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "system",
                  tab: "系统配置"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_form, {
                          "label-col": { span: 8 },
                          "wrapper-col": { span: 16 }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "注册分配的角色" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: formState.assignedRole,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.assignedRole) = $event)),
                                  style: {"width":"320px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: "user" }, {
                                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                                        _createTextVNode("普通用户")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { label: "和风天气秘钥" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: formState.weatherApiKey,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.weatherApiKey) = $event)),
                                  placeholder: "请输入秘钥",
                                  style: {"width":"320px"}
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { label: "问题反馈通知用户" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: formState.feedbackNotifyUser,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.feedbackNotifyUser) = $event)),
                                  placeholder: "请输入用户名",
                                  style: {"width":"320px"}
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { label: "是否检查用户注销" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: formState.checkUserLogout,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.checkUserLogout) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: "disallow" }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("禁止项目管理员注销账号")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: "allow" }, {
                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode("允许项目管理员注销账号")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { label: "启用单点会话登录" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: formState.enableSSO,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.enableSSO) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: "enable" }, {
                                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode("启用")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: "disable" }, {
                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createTextVNode("禁用")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { label: "操作日志保留时间" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: formState.opLogRetention,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.opLogRetention) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: "permanent" }, {
                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createTextVNode("永久")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: "custom" }, {
                                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                                        _createTextVNode("自定义")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { label: "登陆日志保留时间" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: formState.loginLogRetention,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formState.loginLogRetention) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: "permanent" }, {
                                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                                        _createTextVNode("永久")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio, { value: "custom" }, {
                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                        _createTextVNode("自定义")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 8 } }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  onClick: saveConfig
                                }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("保存")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_form, { layout: "vertical" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "注册自动创建项目和区域" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: formState.autoCreateProject,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formState.autoCreateProject) = $event)),
                                  placeholder: ""
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "dashed",
                                  style: {"width":"100%"}
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_unref(PlusOutlined))
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[19] || (_cache[19] = _createTextVNode(" 新增项目 "))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "app",
                  tab: "应用管理"
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("div", null, "应用管理内容区域", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})